import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UniversityCardComponent } from '@web/shared/ui';
import { CourseCardContainerComponent } from '../course-card-container/course-card-container.component';
import { ClientFeatureOptions } from '@uc/web/shared/data-models';
import { CourseDetails } from '../../models/course-search.models';
import { Product } from '@uc/shared/data-models';

@Component({
	selector: 'uc-course-list-uni',
	templateUrl: './course-list-uni.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [UniversityCardComponent, CourseCardContainerComponent],
})
export class CourseListUniComponent {
	product = input.required<Product>();
	searchTerm = input.required<string>();
	courses = input.required<CourseDetails[]>();
	uniName = input.required<string>();
	uniSlug = input.required<string>();
	uniId = input.required<number>();
	uniLogo = input.required<string>();
	uniCoverImage = input.required<string>();
	externalUrl = input.required<string>();
	externalProspectusUrl = input.required<string>();
	clientFeatures = input.required<ClientFeatureOptions[]>();
	isFavourite = input.required<boolean>();
	recommendedPercentage = input.required<number>();
	privacyPolicyUrl = input.required<string>();
	ugSearchOrderPosition = input.required<number | null>();
	isHECoSSubject = input.required<boolean | null>();
	degreeLevel = input.required<string>();
	region = input.required<string>();
}
